import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Body from "../../components/body/BodyPage";
import MainLinks from "../../components/navlinks/MainLinks";

import {
    MDBAlert,
    MDBBtn,
    MDBCol,
    MDBRow,
    MDBScrollspy,
    MDBScrollspyLink,
    MDBSpinner,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane
} from "mdb-react-ui-kit";
import AccLoginSettings from "../../components/topviews/accountsettings/AccLoginSettings";
import GlobalStreamsNotifcation from "../../components/topviews/accountsettings/GlobalStreamsNotifcation";
import SmartBoxSetting from "../../components/topviews/accountsettings/SmartBoxSetting";
import Streamssettings from "../../components/topviews/accountsettings/Streamssettings";
import UCCSettings from "../../components/topviews/accountsettings/UCCSettings";
import { useAdminContext } from "../../components/adminstore/Admin-Context";
import EditWarning from "../../components/header/EditWarning";
import GLobalStreamsTeam from "../../components/topviews/accountsettings/GlobalStreamsTeam";
import TopSuccess from "../../components/header/TopSuccess";
import TopMessage from "../../components/header/TopMessage";
import { useForm } from "react-hook-form";
import { getStreamSettingsDetails, updateGlobalSettings } from "../../apiclients/streamsapi_bridge";
import SaveChanges from "../../components/topviews/saveCancel";
import { getSbProductName, getStreamsProductName } from "../../apiclients/CommonUtils";
import TabIDConstant from "../../apiclients/TabIDConstant";
function StreamsSettingsLanding(props) {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const previewRef = useRef(null);



    const [files, setFiles] = useState([]);
    const [basicActive, setBasicActive] = useState('tab1');
    const { isEdited, setEdited } = useAdminContext();
    const [targetView, setTargetView] = useState("");
    const [showWarning, setShowWarning] = useState(false);
    const warningToggle = () => setShowWarning(!showWarning);
    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const [rerender, setrerender] = useState(true);
    const [successMessage, setSuccessMessage] = useState("");
    const streamsProductName = getStreamsProductName();
    const sbProductName = getSbProductName();
    const isSmartBoxVisible =
        JSON.parse(sessionStorage.getItem("admin_session"))?.isSmartBoxVisible ?? 1;

    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }
        if (isEdited) {
            setTargetView(value);
            setShowWarning(true);
            return;
        }
        setBasicActive(value);
    };

    const handleOk = () => {
        setEdited(false);
        setBasicActive(targetView);
        setShowWarning(false);
    };


    const section1 = useRef(null);
    const section2 = useRef(null);
    const section3 = useRef(null);
    const section4 = useRef(null);
    const section5 = useRef(null);

    const containerRef = useRef(null);

    const { register, handleSubmit, formState: { errors, isDirty, dirtyFields }, reset, setError, watch, setValue } = useForm({
        defaultValues: {
            global_settings: {
                streams_settings: {
                    logins: false,
                    allow_users: false,
                    smartbox_enable: false,
                    user_create_notify: false,
                    user_delete_notify: false,
                    search_public_team: false,
                    create_public_teams: false,
                    show_colleagues_team: false,
                    show_company_teams: false,
                    sms: false,
                    delete_msg: false,
                    do_not_disturb: false

                }
            }
        }
    })

    useEffect(() => {
        if (rerender) {
            getLoginSettings();
            setrerender(false);
        }

    }, [rerender]);
    async function getLoginSettings() {
        try {
            setIsloading(true);
            setInternalError(false);
            const response = await getStreamSettingsDetails(JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid,
            TabIDConstant.STREAMS_SETT_SUBLINK
        );
            const rawData = await response.json();
            console.log("getLoginSettings details :::::: " + JSON.stringify(rawData));
            if (response.status === 200) {
                reset({
                    global_settings: {
                        streams_settings: {
                            logins: rawData?.streams_settings?.logins ?? false,
                            allow_users: rawData?.streams_settings?.allow_users ?? false,
                            smartbox_enable: rawData?.streams_settings?.smartbox_enable ?? false,
                            user_create_notify: rawData?.streams_settings?.user_create_notify ?? false,
                            user_delete_notify: rawData?.streams_settings?.user_delete_notify ?? false,
                            search_public_team: rawData?.streams_settings?.search_public_team ?? false,
                            create_public_teams: rawData?.streams_settings?.create_public_teams ?? false,
                            show_colleagues_team: rawData?.streams_settings?.show_colleagues_team ?? false,
                            show_company_teams: rawData?.streams_settings?.show_company_teams ?? false,
                            sms: rawData?.streams_settings?.sms ?? false,
                            delete_msg: rawData?.streams_settings?.delete_msg ?? false,
                            do_not_disturb: rawData?.streams_settings?.do_not_disturb ?? false

                        }

                    }
                });
                console.log("Form values after reset:", watch())


            } else if (response.status === 500) {
                setInternalError(true);
            } else {
                // navigate("/");
                setInternalError(true);
            }
        } catch (e) {
            console.log(`Unable to process the request:${e}`);
            setInternalError(true);
        } finally {
            setIsloading(false);
        }
    }

    const isSave =
        Object.keys(dirtyFields).length === 0 ? false : true;

    function closeSave(e) {
        reset();

    }


    const onSubmit = async (data) => {
        setIsloading(true);
        if (isDirty) {
            let modifiedData = extractModifiedFields(dirtyFields, data)

            if (modifiedData) {


                modifiedData.reqid = 64;
                modifiedData.siteid = JSON.parse(
                    sessionStorage.getItem("admin_session")
                ).siteid;



                console.log("update MFA::::: " + JSON.stringify(modifiedData));
                let saverep = await updateGlobalSettings(modifiedData);
                console.log("login settings :::::: " + saverep);
                setTimeout(() => {
                    setIsloading(false);
                }, 1000);
                let saverepeMsg = await saverep.json();
                console.log("response login settings::::: " + JSON.stringify(saverepeMsg))
                //alert(saverepeMsg.status);
                if (saverepeMsg.status && saverepeMsg.status == "success") {
                    setSuccessMessage(saverepeMsg.message);
                    setrerender(true);
                } else {
                    if (saverepeMsg.message?.errors) {
                        saverepeMsg.message.errors.forEach((err) => {
                            setError(err.param_name, {
                                type: "server",
                                message: err.message,
                            });
                            const fieldElement = document.querySelector(
                                `input[name="${err.param_name}"]`
                            );
                            if (fieldElement) {
                                fieldElement.focus();
                            }
                        });
                    }

                }
            }
        }
    }

    function extractModifiedFields(dirtyFields, data) {
        const modifiedData = {};

        function recurse(dirtyFields, data, modifiedData) {
            for (const field of Object.keys(dirtyFields)) {
                if (dirtyFields[field] && data.hasOwnProperty(field)) {
                    if (typeof data[field] === "object" && !Array.isArray(data[field])) {
                        modifiedData[field] = {};
                        recurse(dirtyFields[field], data[field], modifiedData[field]);
                    } else {
                        modifiedData[field] = data[field];
                    }
                }
            }
        }

        recurse(dirtyFields, data, modifiedData);
        return modifiedData;
    }


    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const scrollspyLinks = document.querySelectorAll(".nav-link");
            const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
            const stickyParent = lastLink.closest(".sticky-top");
            if (stickyParent && lastLink.classList.contains("active")) {
                lastLink.classList.remove("active");
                for (let i = 0; i < scrollspyLinks.length; i++) {
                    const firstLink = scrollspyLinks[i];
                    const parent = firstLink.closest(".sticky-top");
                    if (parent) {
                        firstLink.classList.add("active");
                        break;
                    }
                }
            }
        }, 100);
        return () => clearTimeout(timeoutId);
    }, []);



    return (
        <React.Fragment>
            <>
                <MainLinks active={6} />
                <Body
                    tablinks={6}
                    sublink={269}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3 px-0">
                                        <h5 className="fw-600">
                                            {t("streamssettings", { "PRODUCT_NAME" : streamsProductName })}
                                        </h5>
                                    </div>


                                    <MDBTabs className='mb-3'>
                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                Settings
                                            </MDBTabsLink>
                                        </MDBTabsItem>
                                    </MDBTabs>

                                    <MDBTabsContent>
                                        <MDBTabsPane open={basicActive === 'tab1'}>

                                            <MDBRow>
                                                <MDBCol
                                                    size="2"
                                                    md="2"
                                                    lg="2"
                                                    sm="12"
                                                    className="col-sm-100 pr-0 leftTabs"
                                                >
                                                    <MDBScrollspy container={containerRef}>
                                                        <MDBScrollspyLink targetRef={section1}>
                                                            Login Settings
                                                        </MDBScrollspyLink>
                                                        {isSmartBoxVisible != 0 && (
                                                        <MDBScrollspyLink targetRef={section2}>
                                                            {`${sbProductName} Settings`}
                                                        </MDBScrollspyLink>
                                                        )}
                                                        <MDBScrollspyLink targetRef={section3}>
                                                            {`${streamsProductName} Notifications`}
                                                        </MDBScrollspyLink>
                                                        <MDBScrollspyLink targetRef={section4}>
                                                            {`${streamsProductName} Settings`}
                                                        </MDBScrollspyLink>
                                                        <MDBScrollspyLink targetRef={section5}>
                                                            {`${streamsProductName} Teams`}
                                                        </MDBScrollspyLink>
                                                    </MDBScrollspy>
                                                </MDBCol>

                                                <MDBCol
                                                    size="12"
                                                    md="10"
                                                    sm="12"
                                                    pr-0
                                                    className="col-sm-100 pr-0 leftTabContent"
                                                >

                                                    <div ref={containerRef} className="scrollspy-example" style={{ maxHeight: "100vh !important" }}>
                                                        <section ref={section1} id="section-1">
                                                            <div class="general-settings" style={{ paddingLeft: "10px" }}>Multi Login Settings</div>
                                                            <AccLoginSettings
                                                                register={register}
                                                                setValue={setValue}
                                                                errors={errors}
                                                                watch={watch}
                                                            />
                                                        </section>
                                                        {isSmartBoxVisible != 0 && (
                                                            <>
                                                        <div className="routing-border"></div>
                                                        <section ref={section2} id="section-2">
                                                            <div class="general-settings" style={{ paddingLeft: "10px" }}>{sbProductName} Settings</div>
                                                            <SmartBoxSetting
                                                                register={register}
                                                                setValue={setValue}
                                                                errors={errors}
                                                                watch={watch}
                                                            />
                                                        </section>
                                                            </>
                                                        )}
                                                        <div className="routing-border"></div>
                                                        <section ref={section3} id="section-3">
                                                            <div class="general-settings" style={{ paddingLeft: "10px" }}>
                                                                {`${streamsProductName} Notifications`}
                                                            </div>
                                                            <GlobalStreamsNotifcation
                                                                register={register}
                                                                setValue={setValue}
                                                                errors={errors}
                                                                watch={watch}
                                                            />
                                                        </section>
                                                        <div className="routing-border"></div>
                                                        <section ref={section4} id="section-4">
                                                            <div class="general-settings" style={{ paddingLeft: "10px" }}>
                                                                {`${streamsProductName} Settings`}
                                                            </div>
                                                            <Streamssettings
                                                                register={register}
                                                                setValue={setValue}
                                                                errors={errors}
                                                                watch={watch}
                                                            />
                                                        </section>
                                                        <div className="routing-border"></div>
                                                        <section ref={section5} id="section-5" style={{ paddingBottom: "270px" }}>
                                                            <div class="general-settings" style={{ paddingLeft: "10px" }}>
                                                                {`${streamsProductName} Teams`}
                                                            </div>
                                                            <GLobalStreamsTeam
                                                                register={register}
                                                                setValue={setValue}
                                                                errors={errors}
                                                                watch={watch}
                                                            />
                                                        </section>
                                                    </div>
                                                    {(isSave) && (
                                                        <SaveChanges
                                                            onClose={closeSave}
                                                            isdirtyFields={isSave}
                                                            onSave={(e) => {
                                                                e.preventDefault();
                                                                handleSubmit(onSubmit)();
                                                            }}
                                                        />
                                                    )}

                                                </MDBCol>
                                            </MDBRow>
                                        </MDBTabsPane>
                                    </MDBTabsContent>






















                                    {/* <MDBTabs className='mb-3'>
                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                Login Settings
                                            </MDBTabsLink>
                                        </MDBTabsItem>
                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                                                UCC Settings
                                            </MDBTabsLink>
                                        </MDBTabsItem>
                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab3')} active={basicActive === 'tab3'}>
                                                SmartBox Settings
                                            </MDBTabsLink>
                                        </MDBTabsItem>
                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab4')} active={basicActive === 'tab4'}>
                                                Streams Notifications
                                            </MDBTabsLink>
                                        </MDBTabsItem>
                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab5')} active={basicActive === 'tab5'}>
                                                Streams Settings
                                            </MDBTabsLink>
                                        </MDBTabsItem>
                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab6')} active={basicActive === 'tab6'}>
                                                Streams Teams
                                            </MDBTabsLink>
                                        </MDBTabsItem>
                                    </MDBTabs>

                                    <MDBTabsContent>
                                        <MDBTabsPane open={basicActive === 'tab1'}>
                                            <section ref={section1} id='section-1' className="p-3 w-70 mob-w-100">
                                                <AccLoginSettings
                                                    setEdited={setEdited}
                                                />
                                            </section>

                                        </MDBTabsPane>
                                        <MDBTabsPane open={basicActive === 'tab2'}>

                                            <section ref={section2} id='section-2' className="p-3 w-70  mob-w-100">
                                                <UCCSettings
                                                    setEdited={setEdited}
                                                />
                                            </section>
                                        </MDBTabsPane>
                                        <MDBTabsPane open={basicActive === 'tab3'}>


                                            <section ref={section3} id='section-3' className="p-3 w-70  mob-w-100">

                                              
                                                <SmartBoxSetting
                                                    setEdited={setEdited}
                                                />

                                            </section>
                                        </MDBTabsPane>
                                        <MDBTabsPane open={basicActive === 'tab4'}>

                                            <section ref={section4} id='section-4' className="p-3 w-70  mob-w-100">

                                                <GlobalStreamsNotifcation
                                                    setEdited={setEdited}
                                                />
                                            </section>
                                        </MDBTabsPane>
                                        <MDBTabsPane open={basicActive === 'tab5'}>

                                            <section ref={section4} id='section-4' className="p-3 w-70  mob-w-100">

                                                <Streamssettings
                                                    setEdited={setEdited}
                                                />
                                            </section>
                                        </MDBTabsPane>

                                        <MDBTabsPane open={basicActive === "tab6"}>
                                            <section ref={section4} id='section-4' className="p-3 w-70  mob-w-100">
                                                <GLobalStreamsTeam setEdited={setEdited} />
                                            </section>
                                        </MDBTabsPane>

                                    </MDBTabsContent> */}
                                </div>
                            </section>
                        </>
                    }
                />
                {isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner
                                    size="sm"
                                    role="status"
                                    tag="span"
                                    className="me-2"
                                />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )}
                {internalError && (
                    <MDBAlert
                        open
                        className="alert-center"
                        color="danger"
                        autohide
                        position="bottom-right"
                        delay={5000}
                        onClose={() => setInternalError(false)}
                    >
                        Internal Server Error
                    </MDBAlert>
                )}
                {showWarning && (
                    <EditWarning
                        warningToggle={warningToggle}
                        setShowWarning={setShowWarning}
                        onOk={handleOk}
                    />
                )}

                {successMessage && (
                    <>
                        <TopSuccess>
                            <TopMessage successMessage={successMessage} />
                        </TopSuccess>
                    </>
                )}
                {/* <Footer /> */}
            </>
        </React.Fragment>
    );
}

export default StreamsSettingsLanding